module.exports = __webpack_public_path__ + "static/media/abaddon.788a6f17.png";